export default __webpack_public_path__ + "static/media/cyber-security.c1825374.jpg";